(function () {
	Vue.component('nominow-metric', {
		props: {
			amountpctclass: {
				type: String,
				required: true,
				default: 'amountpctclass'
			},
			amountpct: {
				type: String,
				required: true,
				default: 'amountpct'
			},
			amount1: {
				type: String,
				required: true,
				default: 'amount1'
			},
			amount1text: {
				type: String,
				required: true,
				default: 'amount1text'
			},
			amount2: {
				type: String,
				required: true,
				default: 'amount2'
			},
			amount2text: {
				type: String,
				required: true,
				default: ''
			}
		},
		template: `
            <div class="content">
                <p>
                    <span class="is-size-3">{{ amount1 }} </span>
                    <span class="has-text-light is-italic"> {{ amount1text }} </span>
                    <span :class="amountpctclass"> {{ amountpct }}</span>
                </p>
                <p>{{ amount2 }} <span class="has-text-light is-italic">{{ amount2text }}</span></p>
            </div>
        `
	});
})();
